// const API_VERSION = "1.0.0";
export const SITE_NAME = "Xclusive Can Limited Admin";
export const CURRENCY = "৳";

// export const FRONTEND_URL = "http://localhost:3000";
export const FRONTEND_URL = "https://xclusivecanltd.com";

// export const ROOT_URL = "http://localhost:8045";
export const ROOT_URL = "https://api.xclusivecanltd.com";
export const IMAGE_URL = `${ROOT_URL}/files`;
export const FILE_URL = `${ROOT_URL}/files`;

const API_URL = `${ROOT_URL}`;

export const UPLOAD_IMAGE_URL = `${API_URL}/upload-image`;
export const FILE_UPLOAD_URL = `${ROOT_URL}/upload-file`;

// auth
export const LOGIN_URL = `${API_URL}/login`;
export const REFRESH_TOKEN = `${API_URL}/login/refresh-token`;

// user
export const GET_ALL_USER = `${API_URL}/users`;
export const GET_USER_PROFILE = `${API_URL}/profile`;
export const GET_USER_BY_ID = `${API_URL}/users/id`;
export const CREATE_USER_URL = `${API_URL}/users/create`;
export const UPDATE_USER_URL = `${API_URL}/users/update`;
export const CHANGE_PASSWORD_URL = `${API_URL}/users/change-user-password`;
export const DELETE_USER_URL = `${API_URL}/users/delete`;
export const UPLOAD_PROFILE_IMAGE = `${API_URL}/upload/profile-image`;

// static page
export const GET_ALL_STATIC_PAGES = `${API_URL}/static-page`;
export const GET_STATIC_PAGE_BY_ID = `${API_URL}/static-page/id`;
export const CREATE_STATIC_PAGE_URL = `${API_URL}/static-page/create`;
export const UPDATE_STATIC_PAGE_URL = `${API_URL}/static-page/update`;
export const DELETE_STATIC_PAGE_URL = `${API_URL}/static-page/delete`;
export const UPLOAD_STATIC_PAGE_IMAGE_URL = `${API_URL}/upload-image`;

// site config
export const GET_ALL_SITE_CONFIGS = `${API_URL}/site-config`;
export const GET_SITE_CONFIG_BY_ID = `${API_URL}/site-config/id`;
export const CREATE_SITE_CONFIG_URL = `${API_URL}/site-config/create`;
export const UPDATE_SITE_CONFIG_URL = `${API_URL}/site-config/update`;
export const DELETE_SITE_CONFIG_URL = `${API_URL}/site-config/delete`;
export const UPLOAD_SITE_CONFIG_LOGO_URL = `${API_URL}/upload-image`;

// banner
export const GET_ALL_BANNERS = `${API_URL}/banners`;
export const GET_BANNER_BY_ID = `${API_URL}/banners/id`;
export const CREATE_BANNER_URL = `${API_URL}/banners/create`;
export const UPDATE_BANNER_URL = `${API_URL}/banners/update`;
export const DELETE_BANNER_URL = `${API_URL}/banners/delete`;

// whyChooseUs
export const GET_ALL_WHYCHOOSEUS = `${API_URL}/whyChooseUs`;
export const GET_WHYCHOOSEUS_BY_ID = `${API_URL}/whyChooseUs/id`;
export const CREATE_WHYCHOOSEUS_URL = `${API_URL}/whyChooseUs/create`;
export const UPDATE_WHYCHOOSEUS_URL = `${API_URL}/whyChooseUs/update`;
export const DELETE_WHYCHOOSEUS_URL = `${API_URL}/whyChooseUs/delete`;

// pricing
export const GET_ALL_PRICING = `${API_URL}/pricing`;
export const GET_PRICING_BY_ID = `${API_URL}/pricing/id`;
export const CREATE_PRICING_URL = `${API_URL}/pricing/create`;
export const UPDATE_PRICING_URL = `${API_URL}/pricing/update`;
export const DELETE_PRICING_URL = `${API_URL}/pricing/delete`;

// instructors
export const GET_ALL_INSTRUCTORS = `${API_URL}/instructors`;
export const GET_INSTRUCTORS_BY_ID = `${API_URL}/instructors/id`;
export const CREATE_INSTRUCTORS_URL = `${API_URL}/instructors/create`;
export const UPDATE_INSTRUCTORS_URL = `${API_URL}/instructors/update`;
export const DELETE_INSTRUCTORS_URL = `${API_URL}/instructors/delete`;

// contact
export const GET_ALL_CONTACT = `${API_URL}/contact-message`;
export const GET_CONTACT_BY_ID = `${API_URL}/contact-message/id`;
export const CREATE_CONTACT_URL = `${API_URL}/contact-message/create`;
export const UPDATE_CONTACT_URL = `${API_URL}/contact-message/update`;
export const DELETE_CONTACT_URL = `${API_URL}/contact-message/delete`;

// about
export const GET_ALL_ABOUT = `${API_URL}/about`;
export const GET_ABOUT_BY_ID = `${API_URL}/about/id`;
export const CREATE_ABOUT_URL = `${API_URL}/about/create`;
export const UPDATE_ABOUT_URL = `${API_URL}/about/update`;
export const DELETE_ABOUT_URL = `${API_URL}/about/delete`;

// gallery
export const GET_ALL_GALLERY = `${API_URL}/gallery`;
export const GET_GALLERY_BY_ID = `${API_URL}/gallery/id`;
export const CREATE_GALLERY_URL = `${API_URL}/gallery/create`;
export const UPDATE_GALLERY_URL = `${API_URL}/gallery/update`;
export const DELETE_GALLERY_URL = `${API_URL}/gallery/delete`;

// faq
export const GET_ALL_FAQ = `${API_URL}/faq`;
export const GET_FAQ_BY_ID = `${API_URL}/faq/id`;
export const CREATE_FAQ_URL = `${API_URL}/faq/create`;
export const UPDATE_FAQ_URL = `${API_URL}/faq/update`;
export const DELETE_FAQ_URL = `${API_URL}/faq/delete`;

// products
export const GET_ALL_PRODUCTS = `${API_URL}/products`;
export const GET_PRODUCTS_BY_ID = `${API_URL}/products/id`;
export const CREATE_PRODUCTS_URL = `${API_URL}/products/create`;
export const UPDATE_PRODUCTS_URL = `${API_URL}/products/update`;
export const DELETE_PRODUCTS_URL = `${API_URL}/products/delete`;

// category
export const GET_ALL_CATEGORY = `${API_URL}/category`;
export const GET_CATEGORY_BY_ID = `${API_URL}/category/id`;
export const CREATE_CATEGORY_URL = `${API_URL}/category/create`;
export const UPDATE_CATEGORY_URL = `${API_URL}/category/update`;
export const DELETE_CATEGORY_URL = `${API_URL}/category/delete`;

// managingSupplyChain
export const GET_ALL_MANAGINGSUPPLYCHAIN = `${API_URL}/managingSupplyChain`;
export const GET_MANAGINGSUPPLYCHAIN_BY_ID = `${API_URL}/managingSupplyChain/id`;
export const CREATE_MANAGINGSUPPLYCHAIN_URL = `${API_URL}/managingSupplyChain/create`;
export const UPDATE_MANAGINGSUPPLYCHAIN_URL = `${API_URL}/managingSupplyChain/update`;
export const DELETE_MANAGINGSUPPLYCHAIN_URL = `${API_URL}/managingSupplyChain/delete`;

// news
export const GET_ALL_NEWS = `${API_URL}/news`;
export const GET_NEWS_BY_ID = `${API_URL}/news/id`;
export const CREATE_NEWS_URL = `${API_URL}/news/create`;
export const UPDATE_NEWS_URL = `${API_URL}/news/update`;
export const DELETE_NEWS_URL = `${API_URL}/news/delete`;

// pressRelease
export const GET_ALL_PRESSRELEASE = `${API_URL}/pressRelease`;
export const GET_PRESSRELEASE_BY_ID = `${API_URL}/pressRelease/id`;
export const CREATE_PRESSRELEASE_URL = `${API_URL}/pressRelease/create`;
export const UPDATE_PRESSRELEASE_URL = `${API_URL}/pressRelease/update`;
export const DELETE_PRESSRELEASE_URL = `${API_URL}/pressRelease/delete`;

// blog
export const GET_ALL_BLOG = `${API_URL}/blog`;
export const GET_BLOG_BY_ID = `${API_URL}/blog/id`;
export const CREATE_BLOG_URL = `${API_URL}/blog/create`;
export const UPDATE_BLOG_URL = `${API_URL}/blog/update`;
export const DELETE_BLOG_URL = `${API_URL}/blog/delete`;

// videos
export const GET_ALL_VIDEOS = `${API_URL}/videos`;
export const GET_VIDEOS_BY_ID = `${API_URL}/videos/id`;
export const CREATE_VIDEOS_URL = `${API_URL}/videos/create`;
export const UPDATE_VIDEOS_URL = `${API_URL}/videos/update`;
export const DELETE_VIDEOS_URL = `${API_URL}/videos/delete`;

// brands
export const GET_ALL_BRANDS = `${API_URL}/brands`;
export const GET_BRANDS_BY_ID = `${API_URL}/brands/id`;
export const CREATE_BRANDS_URL = `${API_URL}/brands/create`;
export const UPDATE_BRANDS_URL = `${API_URL}/brands/update`;
export const DELETE_BRANDS_URL = `${API_URL}/brands/delete`;

// certificates
export const GET_ALL_CERTIFICATES = `${API_URL}/certificates`;
export const GET_CERTIFICATES_BY_ID = `${API_URL}/certificates/id`;
export const CREATE_CERTIFICATES_URL = `${API_URL}/certificates/create`;
export const UPDATE_CERTIFICATES_URL = `${API_URL}/certificates/update`;
export const DELETE_CERTIFICATES_URL = `${API_URL}/certificates/delete`;

// challenges
export const GET_ALL_CHALLENGES = `${API_URL}/challenges`;
export const GET_CHALLENGES_BY_ID = `${API_URL}/challenges/id`;
export const CREATE_CHALLENGES_URL = `${API_URL}/challenges/create`;
export const UPDATE_CHALLENGES_URL = `${API_URL}/challenges/update`;
export const DELETE_CHALLENGES_URL = `${API_URL}/challenges/delete`;

// solutions
export const GET_ALL_SOLUTIONS = `${API_URL}/solutions`;
export const GET_SOLUTIONS_BY_ID = `${API_URL}/solutions/id`;
export const CREATE_SOLUTIONS_URL = `${API_URL}/solutions/create`;
export const UPDATE_SOLUTIONS_URL = `${API_URL}/solutions/update`;
export const DELETE_SOLUTIONS_URL = `${API_URL}/solutions/delete`;

// services
export const GET_ALL_SERVICES = `${API_URL}/services`;
export const GET_SERVICES_BY_ID = `${API_URL}/services/id`;
export const CREATE_SERVICES_URL = `${API_URL}/services/create`;
export const UPDATE_SERVICES_URL = `${API_URL}/services/update`;
export const DELETE_SERVICES_URL = `${API_URL}/services/delete`;

// testimonial
export const GET_ALL_TESTIMONIAL = `${API_URL}/testimonial`;
export const GET_TESTIMONIAL_BY_ID = `${API_URL}/testimonial/id`;
export const CREATE_TESTIMONIAL_URL = `${API_URL}/testimonial/create`;
export const UPDATE_TESTIMONIAL_URL = `${API_URL}/testimonial/update`;
export const DELETE_TESTIMONIAL_URL = `${API_URL}/testimonial/delete`;

// conclusion
export const GET_ALL_CONCLUSION = `${API_URL}/conclusion`;
export const GET_CONCLUSION_BY_ID = `${API_URL}/conclusion/id`;
export const CREATE_CONCLUSION_URL = `${API_URL}/conclusion/create`;
export const UPDATE_CONCLUSION_URL = `${API_URL}/conclusion/update`;
export const DELETE_CONCLUSION_URL = `${API_URL}/conclusion/delete`;

// rnd
export const GET_ALL_RND = `${API_URL}/rnd`;
export const GET_RND_BY_ID = `${API_URL}/rnd/id`;
export const CREATE_RND_URL = `${API_URL}/rnd/create`;
export const UPDATE_RND_URL = `${API_URL}/rnd/update`;
export const DELETE_RND_URL = `${API_URL}/rnd/delete`;

// toolRoom
export const GET_ALL_TOOLROOM = `${API_URL}/toolRoom`;
export const GET_TOOLROOM_BY_ID = `${API_URL}/toolRoom/id`;
export const CREATE_TOOLROOM_URL = `${API_URL}/toolRoom/create`;
export const UPDATE_TOOLROOM_URL = `${API_URL}/toolRoom/update`;
export const DELETE_TOOLROOM_URL = `${API_URL}/toolRoom/delete`;

// job
export const GET_ALL_JOB = `${API_URL}/job`;
export const GET_JOB_BY_ID = `${API_URL}/job/id`;
export const CREATE_JOB_URL = `${API_URL}/job/create`;
export const UPDATE_JOB_URL = `${API_URL}/job/update`;
export const DELETE_JOB_URL = `${API_URL}/job/delete`;

// xclusive
export const GET_ALL_XCLUSIVE = `${API_URL}/xclusive`;
export const GET_XCLUSIVE_BY_ID = `${API_URL}/xclusive/id`;
export const CREATE_XCLUSIVE_URL = `${API_URL}/xclusive/create`;
export const UPDATE_XCLUSIVE_URL = `${API_URL}/xclusive/update`;
export const DELETE_XCLUSIVE_URL = `${API_URL}/xclusive/delete`;

// qpail
export const GET_ALL_QPAIL = `${API_URL}/qpail`;
export const GET_QPAIL_BY_ID = `${API_URL}/qpail/id`;
export const CREATE_QPAIL_URL = `${API_URL}/qpail/create`;
export const UPDATE_QPAIL_URL = `${API_URL}/qpail/update`;
export const DELETE_QPAIL_URL = `${API_URL}/qpail/delete`;

// ourStory
export const GET_ALL_OURSTORY = `${API_URL}/ourStory`;
export const GET_OURSTORY_BY_ID = `${API_URL}/ourStory/id`;
export const CREATE_OURSTORY_URL = `${API_URL}/ourStory/create`;
export const UPDATE_OURSTORY_URL = `${API_URL}/ourStory/update`;
export const DELETE_OURSTORY_URL = `${API_URL}/ourStory/delete`;

// ourBusiness
export const GET_ALL_OURBUSINESS = `${API_URL}/ourBusiness`;
export const GET_OURBUSINESS_BY_ID = `${API_URL}/ourBusiness/id`;
export const CREATE_OURBUSINESS_URL = `${API_URL}/ourBusiness/create`;
export const UPDATE_OURBUSINESS_URL = `${API_URL}/ourBusiness/update`;
export const DELETE_OURBUSINESS_URL = `${API_URL}/ourBusiness/delete`;

// members
export const GET_ALL_MEMBERS = `${API_URL}/members`;
export const GET_MEMBERS_BY_ID = `${API_URL}/members/id`;
export const CREATE_MEMBERS_URL = `${API_URL}/members/create`;
export const UPDATE_MEMBERS_URL = `${API_URL}/members/update`;
export const DELETE_MEMBERS_URL = `${API_URL}/members/delete`;

// qualityAssurance
export const GET_ALL_QUALITYASSURANCE = `${API_URL}/qualityAssurance`;
export const GET_QUALITYASSURANCE_BY_ID = `${API_URL}/qualityAssurance/id`;
export const CREATE_QUALITYASSURANCE_URL = `${API_URL}/qualityAssurance/create`;
export const UPDATE_QUALITYASSURANCE_URL = `${API_URL}/qualityAssurance/update`;
export const DELETE_QUALITYASSURANCE_URL = `${API_URL}/qualityAssurance/delete`;

// ourStrength
export const GET_ALL_OURSTRENGTH = `${API_URL}/ourStrength`;
export const GET_OURSTRENGTH_BY_ID = `${API_URL}/ourStrength/id`;
export const CREATE_OURSTRENGTH_URL = `${API_URL}/ourStrength/create`;
export const UPDATE_OURSTRENGTH_URL = `${API_URL}/ourStrength/update`;
export const DELETE_OURSTRENGTH_URL = `${API_URL}/ourStrength/delete`;

// valueProposition
export const GET_ALL_VALUEPROPOSITION = `${API_URL}/valueProposition`;
export const GET_VALUEPROPOSITION_BY_ID = `${API_URL}/valueProposition/id`;
export const CREATE_VALUEPROPOSITION_URL = `${API_URL}/valueProposition/create`;
export const UPDATE_VALUEPROPOSITION_URL = `${API_URL}/valueProposition/update`;
export const DELETE_VALUEPROPOSITION_URL = `${API_URL}/valueProposition/delete`;

// navigationMenu
export const GET_ALL_NAVIGATIONMENU = `${API_URL}/navigationMenu`;
export const GET_NAVIGATIONMENU_BY_ID = `${API_URL}/navigationMenu/id`;
export const CREATE_NAVIGATIONMENU_URL = `${API_URL}/navigationMenu/create`;
export const UPDATE_NAVIGATIONMENU_URL = `${API_URL}/navigationMenu/update`;
export const DELETE_NAVIGATIONMENU_URL = `${API_URL}/navigationMenu/delete`;

// sustainability
export const GET_ALL_SUSTAINABILITY = `${API_URL}/sustainability`;
export const GET_SUSTAINABILITY_BY_ID = `${API_URL}/sustainability/id`;
export const CREATE_SUSTAINABILITY_URL = `${API_URL}/sustainability/create`;
export const UPDATE_SUSTAINABILITY_URL = `${API_URL}/sustainability/update`;
export const DELETE_SUSTAINABILITY_URL = `${API_URL}/sustainability/delete`;

// caseStudies
export const GET_ALL_CASESTUDIES = `${API_URL}/caseStudies`;
export const GET_CASESTUDIES_BY_ID = `${API_URL}/caseStudies/id`;
export const CREATE_CASESTUDIES_URL = `${API_URL}/caseStudies/create`;
export const UPDATE_CASESTUDIES_URL = `${API_URL}/caseStudies/update`;
export const DELETE_CASESTUDIES_URL = `${API_URL}/caseStudies/delete`;

// visitorSpotlight
export const GET_ALL_VISITORSPOTLIGHT = `${API_URL}/visitorSpotlight`;
export const GET_VISITORSPOTLIGHT_BY_ID = `${API_URL}/visitorSpotlight/id`;
export const CREATE_VISITORSPOTLIGHT_URL = `${API_URL}/visitorSpotlight/create`;
export const UPDATE_VISITORSPOTLIGHT_URL = `${API_URL}/visitorSpotlight/update`;
export const DELETE_VISITORSPOTLIGHT_URL = `${API_URL}/visitorSpotlight/delete`;
// CONSTANT_EXPORTS_AREA
export const ACCESS_TOKEN = "factory-gym-token";
export const PROFILE = "fitness-plus-bd-profile";
export const ORDER_STATE_COLOR = {
    INITIATED: "",
    SUPPLIER_ACCEPTED: "cyan",
    DELIVERY_MAN_PICKED: "blue",
    COMPLETED: "green",
    CANCELED: "red"
};
export const GENDER_COLOR = {
    MALE: "blue",
    FEMALE: "green",
    OTHERS: "purple"
};
export const COMPANY = {
    name: "URELAA",
    address: "Dhaka Division, Bangladesh"
};
export const BACK_BUTTON_COLOR = "#3390FF";
// end
